import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PaypalManagementService } from '../../services/PaypalManagement.service';
import { Promoreturnmodal } from '../../models/PromoReturn.model';
import { BuyProductsModal } from '../../models/BuyProducts.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';

@Component({
  selector: 'app-paypal-management-product',
  templateUrl: './paypal-management-product.component.html',
  styleUrls: ['./paypal-management-product.component.css']
})

export class PaypalManagementProductComponent implements OnInit {
  productSelectId;
  quantity: number = 1;
  totalAmount: number = 0;
  product: any;
  initialAmount: number = 0;
  promoName: string = "";
  showAlert: boolean;
  promoReturn: Promoreturnmodal;
  amountToBePaid: number = 0;
  productTotalAmount: number = 0;
  buyProductsModalData: BuyProductsModal[] = [];
  buyProductsModalDataSingle: BuyProductsModal;
  discountProductModalData: Promoreturnmodal;
  addOnServiceArray: any[] = [];
  licenseProduct: any;
  addOnServiceArrayComplete: any[] = [];
  promoFlag: boolean = false;
  promoMessage: string = "";
  allProducts: any[] = [];
  servicesAddOn: any[] = [];
  promoId: string = "";
  isChecked: boolean = false;
  licenseCost: number = 0;
  addedServicess: any[] = [];
  staticSingleProductCost: number = 0;
  serviceCharge: number = 0;
  showLegalMore: boolean = false;
  addOnPrevious: any[] = [];
  addOnPreviousComplete: any[] = [];
  addedServicesComplete: any[] = [];
  validityCount: number = 1;

  constructor(private _service: PaypalManagementService, private _route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.buyProductsModalData = [];
    this.discountProductModalData = new Promoreturnmodal();
    this.discountProductModalData.actualAmount = 0;
    this.discountProductModalData.discountAmount = 0;
    this.discountProductModalData.amountToBePaid = 0;
    this.discountProductModalData.licenseCount = 0;
    this.discountProductModalData.licenseDays = 0;
    this.discountProductModalData.licenseType = 0;
    this.promoReturn = new Promoreturnmodal();
    this.promoReturn.actualAmount = 0;
    this.promoReturn.discountAmount = 0;
    this.promoReturn.amountToBePaid = 0;
    this.promoReturn.licenseCount = 0;
    this.promoReturn.licenseDays = 0;
    this.promoReturn.licenseType = 0;
    this.addOnPrevious = [];
    this.addOnPreviousComplete = [];
    this.buyProductsModalDataSingle = new BuyProductsModal();
    this.showLegalMore = true;
    this._route.queryParams.subscribe(params => {
      this.productSelectId = params['productSelected'], this.quantity = parseInt(params['productQty']), this.promoId = params['promoId'], this.promoName = params['promoName'], this.addOnPrevious = params['addOnPrevious'], this.addOnPreviousComplete = params['addOnPreviousComplete'], this.buyProductsModalData = JSON.parse(params['BuyProductModalSent'])
      this.getSingleSelectedProduct(this.productSelectId);
    });
  }

  getSingleSelectedProduct(productId) {
    this._service.getProducts().subscribe((data: any[]) => {
      this.licenseCost = 0;
      if (this.buyProductsModalData.length == 0) {}
      this.allProducts = data;
      this.product = this.allProducts.filter(i => i.id == productId)[0];
      this.servicesAddOn = this.allProducts.filter(j => j.productType == 2);
      this.licenseProduct = this.allProducts.filter(i => i.productType == 4)[0];
      this.licenseCost = this.allProducts.filter(i => i.productType == 4)[0].amount == null ? 0 : this.allProducts.filter(i => i.productType == 4)[0].amount;
      this.staticSingleProductCost = this.licenseCost + (this.product.amount);
      if (this.buyProductsModalData.length == 0) {
        this.buyProductsModalDataSingle.id = this.product.id;
        this.buyProductsModalDataSingle.tax = this.product.taxPercentage;
        this.buyProductsModalDataSingle.amount = this.product.amount;
        this.buyProductsModalDataSingle.qty = 1;
        this.buyProductsModalDataSingle.name = this.product.productName;
        this.buyProductsModalDataSingle.productType = this.product.productType;
        this.buyProductsModalDataSingle.accessType = this.product.accessType;
        this.buyProductsModalDataSingle.isReoccurred = this.product.isReoccurred;
        this.buyProductsModalDataSingle.isQtyFixed = this.product.isQtyFixed;
        this.buyProductsModalDataSingle.isMonthWise = this.product.isMonthWise;
        this.buyProductsModalDataSingle.productPriceNamePeriod = this.product.productPriceNamePeriod;
        this.buyProductsModalDataSingle.hasValidity = this.product.hasValidity;
        this.buyProductsModalData.push(this.buyProductsModalDataSingle);
        this.buyProductsModalDataSingle = new BuyProductsModal();
        this.buyProductsModalDataSingle.id = this.licenseProduct.id;
        this.buyProductsModalDataSingle.tax = this.licenseProduct.taxPercentage;
        this.buyProductsModalDataSingle.amount = this.licenseProduct.amount;
        this.buyProductsModalDataSingle.qty = this.quantity;
        this.buyProductsModalDataSingle.name = this.licenseProduct.productName;
        this.buyProductsModalDataSingle.productType = this.licenseProduct.productType;
        this.buyProductsModalDataSingle.accessType = this.licenseProduct.accessType;
        this.buyProductsModalDataSingle.isReoccurred = this.licenseProduct.isReoccurred;
        this.buyProductsModalDataSingle.isQtyFixed = this.licenseProduct.isQtyFixed;
        this.buyProductsModalDataSingle.isMonthWise = this.licenseProduct.isMonthWise;
        this.buyProductsModalDataSingle.productPriceNamePeriod = this.licenseProduct.productPriceNamePeriod;
        this.buyProductsModalDataSingle.hasValidity = this.licenseProduct.hasValidity;
        this.buyProductsModalData.push(this.buyProductsModalDataSingle);
      }
      this.totalAmount = this.staticSingleProductCost;
      this.productTotalAmount = this.totalAmount;
      this.amountToBePaid = this.staticSingleProductCost;
      this.initialAmount = this.staticSingleProductCost;
      if (this.promoId == undefined || this.promoId == null || this.promoId == "") {
        this.totalAmount = this.licenseCost * this.quantity + (this.product.amount);
        this.amountToBePaid = this.licenseCost * this.quantity + (this.product.amount);
        this.productTotalAmount = this.totalAmount;
      } else {
        this.onRedirect(this.productSelectId, this.promoName, this.quantity);
      }
      if ((this.addOnPrevious)) {
        this.addServices(this.addOnPrevious, this.addOnPreviousComplete);
      }
    });
  }

  addServices(addOnPrevious, addOnPreviousComplete) {
    this.addedServicess = [];
    this.addedServicesComplete = [];
    this.addOnServiceArray = [];
    this.addOnServiceArrayComplete = [];
    this.serviceCharge = 0;
    this.addedServicess = JSON.parse(addOnPrevious);
    this.addedServicesComplete = JSON.parse(addOnPreviousComplete);
    for (let i = 0, len = this.addedServicess.length; i < len; i++) {
      this.servicesAddOn.forEach(elementaddonprevious => {
        if (this.addedServicess[i].id == elementaddonprevious.id) {
          elementaddonprevious.isChecked = true;
          this.addOnServiceArray.push({
            id: this.addedServicess[i].id
          });
        }
      });
    }
    for (let i = 0, len = this.addedServicesComplete.length; i < len; i++) {
      this.servicesAddOn.forEach(elementaddonprevious => {
        if (this.addedServicesComplete[i].id == elementaddonprevious.id) {
          elementaddonprevious.isChecked = true;
          this.addOnServiceArrayComplete.push({
            id: this.addedServicesComplete[i].id,
            productName: this.addedServicesComplete[i].productName,
            productDescription: this.addedServicesComplete[i].productDescription,
            amount: this.addedServicesComplete[i].amount,
            qty: this.addedServicesComplete[i].qty,
            total: this.addedServicesComplete[i].total
          });
          elementaddonprevious.qty = this.addedServicesComplete[i].qty;
          elementaddonprevious.total = this.addedServicesComplete[i].total;
        }
      });
      let servChargePush = 0;
      if (this.addOnServiceArrayComplete) {
        this.addOnServiceArrayComplete.forEach(element => {
          servChargePush = servChargePush + element.total;
        });
        this.serviceCharge = servChargePush;
      } else {
        this.serviceCharge = 0;
      }
    }
  }

  addServiceCharge(event, amount, id, productName, productDescription, qty) {
    if (event.target.checked === true) {
      if (qty == 0 || qty == undefined || qty == null) {
        this.servicesAddOn.filter(ij => ij.id == id)[0].qty = 1;
        qty = 1;
      }
      this.isChecked = true;
      let indexOne = this.addOnServiceArray.filter(ij => ij.id == id)[0];
      if (indexOne !== undefined) {
        let indexTwo = this.addOnServiceArray.indexOf(indexOne);
        this.addOnServiceArray.splice(indexTwo, 1);
      }
      this.addOnServiceArray.push({
        "id": id
      });
      this.addOnServiceArrayComplete.push({
        "id": id,
        "productName": productName,
        "amount": amount,
        "productDescription": productDescription,
        "qty": qty,
        "total": amount * qty
      });
      let servChargePush = 0;
      if (this.addOnServiceArrayComplete) {
        this.addOnServiceArrayComplete.forEach(element => {
          servChargePush = servChargePush + element.total;
        });
        this.serviceCharge = servChargePush;
      } else {
        this.serviceCharge = 0;
      }
      let indexServiceMain = this.buyProductsModalData.filter(ij => ij.id == id)[0];
      if (indexServiceMain !== undefined) {
        let indexServiceMainTwo = this.buyProductsModalData.indexOf(indexServiceMain);
        this.buyProductsModalData.splice(indexServiceMainTwo, 1);
      }
      let serviceAddOn = this.servicesAddOn.filter(i => i.id == id)[0];
      this.buyProductsModalDataSingle = new BuyProductsModal();
      this.buyProductsModalDataSingle.id = serviceAddOn.id;
      this.buyProductsModalDataSingle.tax = serviceAddOn.taxPercentage;
      this.buyProductsModalDataSingle.amount = serviceAddOn.amount;
      this.buyProductsModalDataSingle.qty = qty;
      this.buyProductsModalDataSingle.name = serviceAddOn.productName;
      this.buyProductsModalDataSingle.productType = serviceAddOn.productType;
      this.buyProductsModalDataSingle.accessType = serviceAddOn.accessType;
      this.buyProductsModalDataSingle.isReoccurred = serviceAddOn.isReoccurred;
      this.buyProductsModalDataSingle.isQtyFixed = serviceAddOn.isQtyFixed;
      this.buyProductsModalDataSingle.isMonthWise = serviceAddOn.isMonthWise;
      this.buyProductsModalDataSingle.productPriceNamePeriod = serviceAddOn.productPriceNamePeriod;
      this.buyProductsModalDataSingle.hasValidity = serviceAddOn.hasValidity;
      this.buyProductsModalData.push(this.buyProductsModalDataSingle);
    } else {
      qty = 0;
      if (qty == 0) {
        this.servicesAddOn.filter(i => i.id == id)[0].qty = 0;
        this.addOnServiceArrayComplete.filter(i => i.id == id)[0].qty = 0;
      }
      this.isChecked = false;
      let indexOne = this.addOnServiceArray.filter(i => i.id == id)[0];
      if (indexOne !== undefined) {
        let indexTwo = this.addOnServiceArray.indexOf(indexOne);
        this.addOnServiceArray.splice(indexTwo, 1);
      }
      let indexThree = this.addOnServiceArrayComplete.filter(i => i.id == id)[0];
      if (indexThree !== undefined) {
        let indexFour = this.addOnServiceArrayComplete.indexOf(indexThree);
        this.addOnServiceArrayComplete.splice(indexFour, 1);
      }
      let indexServiceSplice = this.buyProductsModalData.filter(i => i.id == id)[0];
      if (indexServiceSplice !== undefined) {
        let indexServiceSpliceOne = this.buyProductsModalData.indexOf(indexServiceSplice);
        this.buyProductsModalData.splice(indexServiceSpliceOne, 1);
      }
      let servCharge = 0;
      if (this.addOnServiceArrayComplete) {
        this.addOnServiceArrayComplete.forEach(element => {
          servCharge = servCharge + element.total;
        });
        this.serviceCharge = servCharge;
      } else {
        this.serviceCharge = 0;
      }
    }
  }
  // AlertClose() {
  //   setTimeout(() => {
  //     this.showAlert = false;
  //   }, 5000);
  // }
  onRedirect(productSelectId, promoName, quantity) {
    this._service.applyPromoCode(productSelectId, promoName, quantity).subscribe(
    (data) => {
      this.promoReturn = new Promoreturnmodal();
      this.promoReturn.actualAmount = 0;
      this.promoReturn.discountAmount = 0;
      this.promoReturn.amountToBePaid = 0;
      this.promoReturn.licenseCount = 0;
      this.promoReturn.licenseDays = 0;
      this.promoReturn.licenseType = 0;
      this.promoReturn = data as Promoreturnmodal;
      this.totalAmount = (this.licenseCost * this.quantity) + this.product.amount;
      this.productTotalAmount = this.promoReturn.amountToBePaid;
      if (this.promoReturn.isValid) {
        this.discountProductModalData = new Promoreturnmodal();
        this.discountProductModalData.actualAmount = 0;
        this.discountProductModalData.discountAmount = 0;
        this.discountProductModalData.amountToBePaid = 0;
        this.discountProductModalData.licenseCount = 0;
        this.discountProductModalData.licenseDays = 0;
        this.discountProductModalData.licenseType = 0;
        this.discountProductModalData = this.promoReturn;
        this.promoFlag = true;
        this.promoMessage = "";
      } else {
        this.cancelPromo();
      }
    },
    (error) => {
      console.log(error);
    });
  }

  changeQty() {
    this.totalAmount = (this.licenseCost * this.quantity) + this.product.amount;
    this.amountToBePaid = this.totalAmount;
    this.productTotalAmount = this.totalAmount;
    this.promoName = "";
    var indexLicense = this.buyProductsModalData.filter(ij => ij.id == this.licenseProduct.id && this.licenseProduct.productType == 4)[0];
    if (indexLicense !== undefined) {
      var indexFour = this.buyProductsModalData.indexOf(indexLicense);
      this.buyProductsModalData[indexFour].qty = this.quantity;
    }
    this.promoReturn = new Promoreturnmodal();
    this.promoReturn.actualAmount = 0;
    this.promoReturn.discountAmount = 0;
    this.promoReturn.amountToBePaid = 0;
    this.promoReturn.licenseCount = 0;
    this.promoReturn.licenseDays = 0;
    this.promoReturn.licenseType = 0;
    this.discountProductModalData = new Promoreturnmodal();
    this.discountProductModalData.actualAmount = 0;
    this.discountProductModalData.discountAmount = 0;
    this.discountProductModalData.amountToBePaid = 0;
    this.discountProductModalData.licenseCount = 0;
    this.discountProductModalData.licenseDays = 0;
    this.discountProductModalData.licenseType = 0;
    this.promoFlag = false;
  }

  // changeQtyinit() {
  //   this.totalAmount = (this.licenseCost * this.quantity) + this.product.amount;
  //   this.amountToBePaid = this.totalAmount;
  // }

  checkQuantity() {
    if (this.quantity == undefined || this.quantity == null || this.quantity < 1) {
      this.quantity = 1;
    }
  }

  // CheckValidity() {

  //   if (this.validityCount == undefined || this.validityCount == null || this.validityCount < 1) {
  //     this.validityCount = 1;
  //   }
  // }
  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  applyPromoCode(promoCode) {
    if (promoCode == "" || promoCode == null || promoCode == undefined) {
      // this.showAlert = true;
      // this.AlertAction = 'ALERT';
      // this.alertText = 'Please Enter Promocode!!!';
      // this.AlertClose();
      AlertMessages.Show('Warning', 'Please Enter Promocode!!!', AlertType.Warning);

    } else {
      this._service.applyPromoCode(this.productSelectId, promoCode, this.quantity).subscribe(
        (data) => {

        this.promoReturn = new Promoreturnmodal();
        this.promoReturn.actualAmount = 0;
        this.promoReturn.discountAmount = 0;
        this.promoReturn.amountToBePaid = 0;
        this.promoReturn.licenseCount = 0;
        this.promoReturn.licenseDays = 0;
        this.promoReturn.licenseType = 0;
        this.promoReturn = data as Promoreturnmodal;
        this.productTotalAmount = this.promoReturn.amountToBePaid;
        if (this.promoReturn.isValid) {
          this.promoFlag = true;
          this.promoMessage = "";
          this.discountProductModalData = new Promoreturnmodal();
          this.discountProductModalData.actualAmount = 0;
          this.discountProductModalData.discountAmount = 0;
          this.discountProductModalData.amountToBePaid = 0;
          this.discountProductModalData.licenseCount = 0;
          this.discountProductModalData.licenseDays = 0;
          this.discountProductModalData.licenseType = 0;
          this.discountProductModalData = this.promoReturn;
        }
        // else {
        //   this.cancelPromo();
        //   this.promoMessage = "Promo Code Is Not Valid";
        // }
      },
      (error) => {
        this.cancelPromo();
          this.promoMessage = "Promo Code Is Not Valid";
      });
    }
  }

  cancelPromo() {
    this.totalAmount = (this.licenseCost * this.quantity) + this.product.amount;
    this.productTotalAmount = this.totalAmount;
    this.amountToBePaid = this.totalAmount;
    this.promoName = "";
    this.promoReturn = new Promoreturnmodal();
    this.promoReturn.actualAmount = 0;
    this.promoReturn.discountAmount = 0;
    this.promoReturn.amountToBePaid = 0;
    this.promoReturn.licenseCount = 0;
    this.promoReturn.licenseDays = 0;
    this.promoReturn.licenseType = 0;
    this.promoReturn.discountAmount=0;
    this.discountProductModalData = new Promoreturnmodal();
    this.discountProductModalData.actualAmount = 0;
    this.discountProductModalData.discountAmount = 0;
    this.discountProductModalData.amountToBePaid = 0;
    this.discountProductModalData.licenseCount = 0;
    this.discountProductModalData.licenseDays = 0;
    this.discountProductModalData.licenseType = 0;
    this.promoFlag = false;
  }

  routeBack() {
    this.router.navigate(['BuyIPSProduct']);
  }

  proceedToCheckout() {
    var promoIdSent = "";
    var finalAmount = 0;
    var discountAmount = 0;
    if (this.promoReturn == null || this.promoReturn == undefined) {
      promoIdSent = "";
      discountAmount = 0;
      finalAmount = (((this.totalAmount + this.serviceCharge) * this.product.taxPercentage) / 100) + ((this.totalAmount + this.serviceCharge));
    } else {
      promoIdSent = this.promoReturn.promoId;
      finalAmount = (this.productTotalAmount + this.serviceCharge + (((this.productTotalAmount + this.serviceCharge) * this.product.taxPercentage) / 100));
      discountAmount = this.promoReturn.discountAmount;
    }
    if (this.productSelectId == null || this.productSelectId == undefined) {
      this.productSelectId = "";
    }
    if (this.quantity == null || this.quantity == undefined) {
      this.quantity = 1;
    }
    let addOn = this.addOnServiceArray;
    let addOnComplete = this.addOnServiceArrayComplete;
    this.router.navigate(['PaypalManagementCustomerInfo'], {
      queryParams: {
        'promoId': promoIdSent,
        'productId': this.productSelectId,
        'productQty': this.quantity,
        'amountToPay': finalAmount,
        'promoName': this.promoName,
        'addOnService': JSON.stringify(addOn),
        'addOnServiceComplete': JSON.stringify(addOnComplete),
        'serviceCompleted': JSON.stringify(addOnComplete),
        'subTotal': this.totalAmount,
        'taxPer': this.product.taxPercentage,
        'servicesCost': this.serviceCharge,
        'taxCost': (((this.productTotalAmount + this.serviceCharge) * this.product.taxPercentage) / 100),
        'discountAmount': discountAmount,
        'BuyProductFinal': JSON.stringify(this.buyProductsModalData),
        'DiscountProductModalData': JSON.stringify(this.discountProductModalData),
        'productTotalAmount': this.productTotalAmount
      },
      skipLocationChange: true
    });
  }

  changeServiceChargeSubtract(id, isChecked, qty, amount) {
    if (isChecked == true) {
      if (isChecked == true) {
        this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].qty = qty;
        this.buyProductsModalData.filter(ij => ij.id == id)[0].qty = qty;
        this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].total = this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].qty * amount;
        var servChargePush = 0;
        if (this.addOnServiceArrayComplete) {
          this.addOnServiceArrayComplete.forEach(element => {
            servChargePush = servChargePush + element.total;
          });
          this.serviceCharge = servChargePush;
        } else {
          this.serviceCharge = 0;
        }
      }
    }
  }

  changeServiceChargeAdd(id, isChecked, qty, amount) {
    if (isChecked == true) {
      this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].qty = qty;
      this.buyProductsModalData.filter(ij => ij.id == id)[0].qty = qty;
      this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].total = this.addOnServiceArrayComplete.filter(ij => ij.id == id)[0].qty * amount;
      var servChargePush = 0;
      if (this.addOnServiceArrayComplete) {
        this.addOnServiceArrayComplete.forEach(element => {
          servChargePush = servChargePush + element.total;
        });
        this.serviceCharge = servChargePush;
      } else {
        this.serviceCharge = 0;
      }
    }
  }
}
